// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyBiPlanMaximizer {
    'atRisk'?: string | null;
    'name'?: string | null;
    'phoneNumber'?: string | null;
    'optInDate'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyBiPlanMaximizer>> = [
        {
            "name":     "atRisk",
            "baseName": "atRisk",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "optInDate",
            "baseName": "optInDate",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyBiPlanMaximizer.attributeTypeMap;
    }
}
